import { Divider, Stack } from '@mui/material'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { STAKING_URL } from '../../../constants/navigation'
import TierRequirementBox from './TierRequirementBox'
import { calcMembershipStatusProgress } from '../../../util/staking/membership.helpers'
import MembershipRequirement from './MembershipRequirement'
import {
  findTierLevelById,
  ONYX_LEVEL_ID
} from '../../../util/staking/staking.helpers'

const PurchaseStatusReq = ({ onCancel, tiers, userTier }) => {
  const tierRequirement = findTierLevelById(tiers, ONYX_LEVEL_ID)
  const { t } = useTranslation()
  const { current, total, completed } = calcMembershipStatusProgress({
    userTier,
    tierRequirement
  })
  const requirements = [
    {
      title: t('kyc.tier-status-required', {
        tier: tierRequirement?.name
      }),
      completed: userTier.tier.id === tierRequirement?.id,
      desc: (
        <MembershipRequirement
          t={t}
          id={tierRequirement?.id}
          current={current}
          total={total}
          completed={completed}
        />
      ),
      rightAction: {
        label: t('brand:staking.stake'),
        component: Link,
        to: STAKING_URL,
        onClick: onCancel
      }
    }
  ]
  return (
    <Stack px={3} pt={3} spacing={3}>
      <Stack spacing={2}>
        {requirements.map((props, index) => (
          <TierRequirementBox key={index} {...props} />
        ))}
      </Stack>
      <Divider sx={{ borderStyle: 'dashed' }} />
    </Stack>
  )
}

export default memo(PurchaseStatusReq)
